module.exports = __webpack_public_path__ + "static/sauer-mobile-3b1b3384e272afd0c31fb192d174528f.jpg";